module.exports = __webpack_public_path__ + "static/media/adria_logo.60a2277b.png";